import BEMHelper from 'react-bem-helper';

import '../sharedStyles/form.sass';
import '../sharedStyles/page.sass';

export type BEMObject = BEMHelper<{ className: string }>;
export type BEMModifiers = string[] | { [key: string]: boolean } | string;

const BEM = (name: string): BEMObject => {
    return new BEMHelper({
        name,
    });
};

export const mergeClasses = (...classes: Array<{ className: string } | string>) => {
    return {
        className: classes.map((c) => (typeof c === 'string' ? c : c.className)).join(' '),
    };
};
export default BEM;

export const pageClasses = BEM('page');
export const formClasses = BEM('form');
export const formRowClass = formClasses('fieldlike', undefined, 'row');
